const defaultData = [
  {
      color: 'primary',
      icon: 'ri-user-smile-line'
  },
  {
    color: 'secondary',
    icon: 'ri-check-double-line'
  },
  {
    color: 'success',
    icon: 'ri-notification-off-line'
  },
  {
      color: 'danger',
      icon: 'ri-error-warning-line'
  }
];

const dismissingData = [
  {
    color: 'warning',
    icon: 'ri-alert-line'
  },
  {
    color: 'info',
    icon: 'ri-airplay-line'
  },
  {
    color: 'light',
    icon: 'ri-airplay-line'
  },
  {
    color: 'dark',
    icon: 'ri-refresh-line'
  }
];
export { defaultData, dismissingData };
